import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdminMerchantSearchPicker from '../components/AdminMerchantSearchPicker';

export default function LoyalPassAdminDashboardPreviewsIndex() {
    const navigate = useNavigate();

    return (
        <div className="p-6 max-w-2xl mx-auto">
            <h1 className="text-2xl font-semibold text-slate-900">Dashboard Previews</h1>
            <p className="text-slate-600 mt-2 text-sm">
                Search for a merchant by name or email, then choose one to open a read-only Dashboard Overview.
            </p>

            <div className="mt-6 rounded-xl border border-slate-200 bg-slate-50/50 p-4">
                <h2 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-3">Find merchant</h2>
                <AdminMerchantSearchPicker
                    autoLoadRecent
                    onSelectMerchant={(id) =>
                        navigate(`/dashboard/loyalpass-admin/dashboard-previews/${id}`)
                    }
                />
            </div>
        </div>
    );
}
